import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, SiteTemplate } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class SiteTemplatesDataService extends HttpBaseService {

    private route = environment.api + 'apps/';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    createSiteTemplate(app: App, siteTemplate: SiteTemplate): Observable<SiteTemplate> {
        const url = `${this.route}${app.id}/projects/${siteTemplate.projectId}/site-templates`;
        return this.httpPost(url, siteTemplate);
    }

    getSiteTemplatesByProject(appId: string, projectId: string): Observable<SiteTemplate[]> {
        const url = `${this.route}${appId}/projects/${projectId}/site-templates`;
        return this.httpGet(url);
    }

    getActiveSiteTemplatesByProject(appId: string, projectId: string): Observable<SiteTemplate[]> {
        const url = `${this.route}${appId}/projects/${projectId}/site-templates?active=true`;
        return this.httpGet(url);
    }

    updateSiteTemplate(appId: string, projectId: string, siteTemplateToUpdate: SiteTemplate): Observable<SiteTemplate> {
        const url = `${this.route}${appId}/projects/${projectId}/site-templates/${siteTemplateToUpdate.id}`;
        return this.httpPut(url, siteTemplateToUpdate);
    }

    updateSiteTemplateActiveStatus(appId: string, projectId: string, siteTemplate: SiteTemplate, newActiveStatus: boolean): Observable<SiteTemplate> {
        const url = `${this.route}${appId}/projects/${projectId}/site-templates/${siteTemplate.id}/active`;
        return this.httpPut(url, newActiveStatus);
    }

    deleteSiteTemplate(appId: string, projectId: string, siteTemplateId: string): Observable<boolean> {
        const url = `${this.route}${appId}/projects/${projectId}/site-templates/${siteTemplateId}`;
        return this.httpDelete(url);
    }
}
